// extracted by mini-css-extract-plugin
export default {"root":"FuzzinessSlider_root__ldwG3"};